import Vue from 'vue';
import Vuex from 'vuex';
import { getUserDetail } from '../api/api-user';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {},
    isIos: false,
    spotId: undefined,
    wechatUrl: '',
    homePage: { read: -1 },
  },
  getters: {
    user: state => state.user,
    spotId: state => state.spotId,
    isIos: state => state.isIos,
    wechatUrl: state => state.wechatUrl,
    homePage: state => state.homePage,
  },
  mutations: {
    setUser: (state, payload) => {
      state.user = payload;
    },
    setSpotId: (state, payload) => {
      state.spotId = payload;
    },
    setIsIos: (state, payload) => {
      state.isIos = payload;
    },
    setWechatUrl: (state, payload) => {
      state.wechatUrl = payload;
    },
    setHomePage: (state, payload) => {
      state.homePage = payload;
    },
  },
  actions: {
    getUser: async ({ commit }) => {
      const {
        id,
        tel,
        name,
        status,
        identityNo,
        credit3: hours,
        credit2: credit,
        member_card: card,
        credit1: integral,
        weixin_avatar: avatar,
        auth_code_img: qrcode,
        is_distribution: more,
        game_name: gameNickName,
        weixin_nickname: nickname,
        total_commission: balance,
        distribution_key: recommendation,
        total_commission: availableCommission,
        total_commission_pay: commissionWithdrew,
      } = await getUserDetail();
      commit('setUser', {
        id,
        tel,
        name,
        card,
        more,
        hours,
        avatar,
        qrcode,
        status,
        credit,
        balance,
        integral,
        nickname,
        identityNo,
        gameNickName,
        recommendation,
        commissionWithdrew,
        availableCommission,
      });
      return status;
    },
    initializePlatform: ({ commit }) => {
      const { userAgent } = window.navigator;
      const isIos = userAgent.includes('iPhone');
      commit('setIsIos', isIos);
    },
    configWechatUrl: ({ commit, state }) => {
      const { isIos, wechatUrl } = state;
      if (isIos && wechatUrl) return;
      commit('setWechatUrl', window.location.href);
    },
  },
});
